var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrab(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9682",
    "data-name": "Rectangle 9682",
    width: 100,
    height: 100,
    transform: "translate(699 3082)",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_88198",
    "data-name": "Group 88198",
    transform: "translate(-822 -5306)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10450",
    "data-name": "Rectangle 10450",
    width: 120,
    height: 120,
    transform: "translate(822 5306)",
    fill: "#defbff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_788",
    "data-name": "Mask Group 788",
    transform: "translate(134 2234)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87976",
    "data-name": "Group 87976",
    transform: "translate(710.866 3096.186)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M62.3,35.813q15.445,0,30.89,0c4.563,0,7.4,2.845,7.4,7.415q0,28.146,0,56.292c0,4.507-2.862,7.37-7.365,7.37q-30.976,0-61.952,0c-4.5,0-7.36-2.864-7.36-7.374q0-28.189,0-56.378c0-4.447,2.876-7.324,7.321-7.325q15.531,0,31.062,0M26.658,51.736v.911q0,23.489,0,46.978c0,2.85,1.666,4.531,4.5,4.532q31.1,0,62.2,0c2.834,0,4.5-1.678,4.5-4.532q0-23.489,0-46.978v-.911Zm71.2-2.79c0-2.033,0-3.967,0-5.9-.005-2.835-1.677-4.5-4.53-4.5q-10.265,0-20.531,0-20.873,0-41.745,0a4.109,4.109,0,0,0-4.393,4.375c-.005,1.395,0,2.79,0,4.184v1.837Z",
    transform: "translate(-23.919 -35.813)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M111.215,159.121H88.92c-1.607,0-1.985-.367-1.985-1.918q0-15.64,0-31.279c0-1.553.382-1.929,1.977-1.93q22.338,0,44.675,0c1.541,0,1.941.391,1.941,1.879q0,15.681,0,31.363c0,1.5-.394,1.883-1.933,1.883q-11.191,0-22.381,0M89.711,126.7v.933c0,5.059.017,10.118-.019,15.176a1.1,1.1,0,0,0,.947,1.28c5.613,1.712,11.174,1.237,16.731-.246a50.516,50.516,0,0,0,9.858-4.235,36.572,36.572,0,0,1,11.119-3.823c1.444-.22,2.9-.346,4.339-.514V126.7Zm.051,20.183v9.507h42.946V138.079a6.209,6.209,0,0,0-1.145.01,52.426,52.426,0,0,0-7.5,1.6,93.355,93.355,0,0,0-9.652,4.291,33.749,33.749,0,0,1-16.745,3.813c-2.636-.129-5.254-.592-7.91-.907",
    transform: "translate(-72.892 -103.393)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M116.871,295.415a3.271,3.271,0,0,1-.679.877c-1.17.844-2.387,1.622-3.593,2.414a1.388,1.388,0,0,1-1.64-.016c-1.2-.8-2.412-1.587-3.6-2.406a1.3,1.3,0,0,1-.441-1.876,1.326,1.326,0,0,1,1.907-.332c.825.512,1.637,1.048,2.421,1.62a.806.806,0,0,0,1.1-.013c.788-.567,1.6-1.11,2.424-1.615.987-.6,2.1-.02,2.1,1.348",
    transform: "translate(-87.731 -234.666)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M236.587,299.348c1.2,0,2.4-.01,3.592,0a1.366,1.366,0,0,1,1.533,1.3,1.381,1.381,0,0,1-1.557,1.365q-3.551.016-7.1,0c-.942,0-1.5-.5-1.512-1.3-.017-.835.548-1.347,1.537-1.358,1.169-.012,2.339,0,3.509,0",
    transform: "translate(-183.997 -238.962)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M174.189,302.015c-1.169,0-2.339.011-3.508,0-.965-.012-1.553-.558-1.528-1.38.025-.785.593-1.278,1.534-1.282q3.55-.015,7.1,0c.939,0,1.507.5,1.528,1.289.022.821-.567,1.363-1.534,1.374-1.2.014-2.394,0-3.592,0",
    transform: "translate(-135.895 -238.959)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M264.783,64.764c1.67,0,3.339-.007,5.009,0,1,.006,1.6.5,1.611,1.3a1.4,1.4,0,0,1-1.573,1.361q-5.092.026-10.185,0a1.4,1.4,0,0,1-1.569-1.364c.014-.793.615-1.288,1.614-1.294,1.7-.01,3.395,0,5.092,0",
    transform: "translate(-204.109 -58.311)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M68.662,66.163a1.313,1.313,0,1,1-2.623-.1,1.313,1.313,0,0,1,2.623.1",
    transform: "translate(-56.652 -58.362)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M92.669,66.142a1.313,1.313,0,1,1-2.625-.059,1.313,1.313,0,0,1,2.625.059",
    transform: "translate(-74.943 -58.362)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M115.349,64.827a1.318,1.318,0,0,1,1.326,1.314,1.313,1.313,0,0,1-2.625.025,1.32,1.32,0,0,1,1.3-1.339",
    transform: "translate(-93.468 -58.361)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M121.736,154a4.664,4.664,0,0,1,4.676,4.652,4.636,4.636,0,1,1-9.272,0,4.672,4.672,0,0,1,4.6-4.65m.023,2.675a2,2,0,0,0-1.963,1.973,1.98,1.98,0,1,0,3.96-.034,1.989,1.989,0,0,0-2-1.939",
    transform: "translate(-95.8 -126.934)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrab);
export default __webpack_public_path__ + "static/media/Grab.85d0e06e2a873897975cdd5140f969f0.svg";
export { ForwardRef as ReactComponent };